<template>
  <el-dialog
    custom-class="theme-dialog"
    title="历史答题记录"
    :visible="true"
    @close="onClose"
    :close-on-click-modal="false"
    width="766px"
  >
    <div class="history-container">
      <div class="history-wrap text-theme-black-850">
        <el-table :data="historyList" height="400">
          <el-table-column label="提交时间" prop="submitTime">
            <template v-slot:default="{ row }">
              <span class="text-medium">{{ row.submitTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="提交次数">
            <template v-slot:default="{ row }">
              <span class="text-medium"> 第 {{ row.submitIdx }} 次</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template v-slot:default="{ row }">
              <el-button type="text" @click="onSelectAnswer(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="text-right pagination-wrap">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="page.current"
          :page-sizes="page.pageSizes"
          :page-size="page.size"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { filterParams, getAnswerHistory } from 'dygc'

export default {
  name: 'HistoryPopup',
  props: {
    accountUserId: {
      type: String,
      default: ''
    },
    accountUserFingerprint: {
      type: String,
      default: ''
    },
    surveyId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      historyList: [],
      total: 0,
      loading: false,
      isLoad: false,
      page: {
        size: 20,
        current: 1,
        total: 0,
        pageSizes: [10, 20, 30, 40, 50, 100]
      }
    }
  },
  created() {
    this.getList()
  },
  computed: {
    finished() {
      return this.historyList.length === this.total
    }
  },
  methods: {
    onSizeChange(val) {
      this.page.size = val
      this.getList()
    },
    onCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    onSelectAnswer(item) {
      this.$bus.answerId = item.id
      this.$bus.openLoading()
      this.$bus.scoreEnd = null
      this.$bus.isOpenReward = true
      this.$bus.getAnswerRes().then(res => {
        setTimeout(() => {
          this.onClose()
        }, 20)
      })
    },
    getList() {
      this.loading = true
      // this.$bus.openLoading()
      const params = {
        accountUserId: this.accountUserId,
        surveyId: this.surveyId,
        accountUserFingerprint: this.accountUserFingerprint,
        size: this.page.size,
        current: this.page.current
      }
      getAnswerHistory(filterParams(params)).then(res => {
        let data = res.data
        this.historyList = data.records
        this.total = data.total
        this.loading = false
        // this.$bus.closeLoading()
        this.isLoad = true
        this.page.size = data.size
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    onClose() {
      if (this.loading) return
      this.$emit('close')
    }
  }
}
</script>
